export interface CheckoutPlanStartDateClientConfig {
  content: string;
}
